import React from 'react';
import './styles.scss';

const Index= (data) => {
  return (
	<div className="form-main-wrapper">
    <div className="form-container">
      <div className="form-body">{data.label}
        <button className="form-button">click here</button>
      </div>
    </div>
	</div>
  );
};

export default Index;
